import React from 'react';

function MichassGalerie() {
	return (
		<div>
			Michass Galerie
		</div>
	);
}

export default MichassGalerie;
